import {
  getPresignedUrl,
  uploadFileToS3,
  getDownloadUrl,
  processReceipt,
} from './services'

type AttachmentType = 'image' | 'pdf'

const getAttachmentType = (mimeType: string): AttachmentType => {
  if (mimeType === 'application/pdf') return 'pdf'
  return 'image'
}

export const uploadReceiptForReimbursement = async (file: File) => {
  try {
    const attachmentType = getAttachmentType(file.type)

    // Get presigned URL
    const presignedResponse = await getPresignedUrl(file.name, attachmentType)
    if (!presignedResponse?.data?.presignedUrl) {
      return { status: 'error', error: 'No presigned URL returned' }
    }

    // Upload file to S3
    const uploadResponse = await uploadFileToS3(
      presignedResponse.data.presignedUrl,
      file
    )
    if (uploadResponse.status !== 200) {
      return { status: 'error', error: 'S3 upload failed' }
    }

    // Get download URL
    const downloadResponse = await getDownloadUrl(file.name, attachmentType)
    if (!downloadResponse?.data?.downloadUrl) {
      return { status: 'error', error: 'No download URL returned' }
    }
    const downloadUrl = downloadResponse.data.downloadUrl

    // Process receipt (OCR)
    const processResponse = await processReceipt(downloadUrl, file.type)
    if (!processResponse?.data) {
      return { status: 'error', error: 'Receipt processing failed' }
    }

    return {
      status: 'success',
      downloadUrl,
    }
  } catch (error) {
    return { status: 'error', error: error.message }
  }
}
